import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    methods: {
        ...mapActions({
            saveAgent: 'agents/saveAgent',
        }),

        ...mapMutations({
            selectAgent: 'agents/SET_SELECTED_AGENT'
        })
    },

    computed: {
        ...mapGetters({
            agents: 'agents/agents',
            selectedAgent: 'agents/selectedAgent',
            selectedAgents: 'agents/selectedAgents'
        })
    }
}